import { BuilderType } from './portalApiHelpers';

export type User = {
  id: number;
  portal_user_id?: number;
  email: string;
  first_name: string;
  last_name: string;
};
export type ResetData = { email: string; password: string; token: string };

export const statisticsApi = (builder: BuilderType) => ({
  getStatistics: builder.query<any, string>({
    query: (date) => `service/accounts/statistics/${date}`,
  }),
  getStatisticsClosestDate: builder.query<any, string>({
    query: (date) => `service/accounts/statistics/closest-date/${date}`,
  }),
});
